// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"0e20c653","581":"259f7a3c","878":"f61c12f6","913":"97c52607"}[chunkId] + ".chunk.js";
};